import { DatePipe } from "@angular/common";
import { HttpClient } from "@angular/common/http";
import { Component, OnInit, Renderer2, ViewChild } from "@angular/core";
import { MatDialog } from "@angular/material";
import { ActivatedRoute, Router } from "@angular/router";
import { DataTableDirective } from "angular-datatables";
import { Subject } from "rxjs";
import { GeneralService } from "src/app/Service/general.service";
import Swal from "sweetalert2";
class DataTablesResponse {
  data: any[];
  draw: number;
  recordsFiltered: number;
  recordsTotal: number;
}

@Component({
  selector: "app-auction-alert",
  templateUrl: "./auction-alert.component.html",
  styleUrls: ["./auction-alert.component.scss"],
})
export class AuctionAlertComponent implements OnInit {
  breadCrumbItems: Array<{}>;
  dtOptions: DataTables.Settings = {};
  @ViewChild(DataTableDirective, { static: false })
  dtElement: DataTableDirective;
  dtTrigger = new Subject<any>();
  UserID: any;
  Data: any;
  isLoading: boolean;
  user: any;
  isEdit: boolean = false;
  Type: any;
  users: any;
  datas: any;
  PlanId: any;
  constructor(
    private router: Router,
    private renderer: Renderer2,
    private datepipe: DatePipe,
    private gs: GeneralService,
    private http: HttpClient,
    private dialog: MatDialog,
    private route: ActivatedRoute
  ) {
    this.Type = this.route.snapshot.params.type;
    if (this.router.getCurrentNavigation()) {
      if (this.router.getCurrentNavigation().extras.state) {
        const state = this.router.getCurrentNavigation().extras.state;
        this.UserID = state["UserId"];
        this.PlanId = state["PlanId"];
        localStorage.setItem("UserId", this.UserID);
        localStorage.setItem("PlanId", this.PlanId);
      } else {
        if (localStorage.getItem("UserId")) {
          this.UserID = localStorage.getItem("UserId");
        }
      }
    }
  }

  ngOnInit() {
    this.getusersbyid();
    this.breadCrumbItems = [
      { label: "User Details", path: "/users/users-users-details" },
      { label: "Auction-alert List", path: "/", active: true },
    ];
    this.dtOptions = {
      pagingType: "simple_numbers",
      pageLength: 10,
      processing: true,
      ordering: true,
      searching: true,
      serverSide: false,
      order: [[0, "desc"]],
      ajax: (dataTablesParameters: any, callback) => {
        // console.log("lin")
        this.http
          .get<DataTablesResponse>(
            // `${this.gs.getLawyer()}/${dataTablesParameters.search.value != '' ? dataTablesParameters.search.value + '/' : ''}${((dataTablesParameters.start + dataTablesParameters.length) / dataTablesParameters.length)}/${dataTablesParameters.length}`,

            `${this.gs.auctionAlertList()}` + `${this.UserID}`
            //  +
            // `&pageNo=${((dataTablesParameters.start + dataTablesParameters.length) / dataTablesParameters.length)}` +
            // `${dataTablesParameters.length.value != '' ? '&PageSize=' + dataTablesParameters.length : ''}`
            //  +  `${dataTablesParameters.search.value != '' ? '&search=' + dataTablesParameters.search.value : ''}` +
            //  `${dataTablesParameters.order ? '&orderKey=' + dataTablesParameters.columns[dataTablesParameters.order[0].column].name : '&orderKey=id'}` +
            //  `${dataTablesParameters.order ? '&ordering=' + dataTablesParameters.order[0].dir : '&ordering=desc'}`
          )
          .subscribe((resp: any) => {
            callback({
              recordsTotal: resp.Count,
              recordsFiltered: resp.Count,
              data: resp.data,
            });
            // console.log(resp.data)
          });
      },
      columns: [
        // {
        //   title: 'Sr.No.',
        //   data: null,
        //   render: (data, type, row, meta) => {
        //     return meta.row + 1;
        //   },
        // },
        {
          title: "Entry_Date",
          data: null,
          render: (data) => {
            if (data.entry_date === "0000-00-00" || data.entry_date == null) {
              return "--";
            } else {
              return this.datepipe.transform(data.entry_date, "dd-MM-yyyy");
            }
          },
        },
        {
          title: "StartDate",
          data: null,
          render: (data) => {
            var date = new Date(data.startDate);
            return data.startDate
              ? this.datepipe.transform(date, "dd-MM-yyyy")
              : "--";
          },
        },
        {
          title: "EndDate",
          data: null,
          render: (data) => {
            var date = new Date(data.endDate);
            return data.endDate
              ? this.datepipe.transform(date, "dd-MM-yyyy")
              : "--";
          },
        },
        {
          title: "ActionFor",
          data: null,
          render: (data) => {
            return data.VillageName
              ? data.VillageName +
                  ", " +
                  data.TalukaName +
                  ", " +
                  data.DistrictName
              : data.TalukaName
              ? data.TalukaName + ", " + data.DistrictName
              : data.DistrictName;
          },
        },

        {
          title: "Action",
          name: "id",
          orderable: false,
          data: null,

          render(data) {
            const serializedData = JSON.stringify(data);
            return `<div style="display:flex" >
            <a class="btn text-primary edit" title="Edit Auction">
            <i class="btn font-18 mdi mdi-content-save-edit-outline text-secondary" UserId="${data.UserSubscriptionMainID}"></i></a> `;
          },
        },
      ],
      drawCallback: () => {
        $(".edit").on("click", (e) => {
          const data = e.target.getAttribute("data");
          this.datas = JSON.parse(decodeURIComponent(data));
          this.router.navigate(
            [
              "users/users-users-details/editAuction/" +
                e.target.getAttribute("UserId"),
            ],
            {
              state: {
                UserId: this.UserID,
                isEdit: true,
                id: e.target.getAttribute("UserId"),
              },
            }
          );
        });
      },
    };
    // this.getusersbyid()
  }
  // getusertpbyid() {
  //   this.gs.getusertpbyid(this.UserID)
  //   .subscribe(
  //     (res: any) => {
  //       this.user = res.data[0];
  //       this.user.MobileNo = this.user.MobileNo.split(',');
  //       this.user.EmailID = this.user.EmailID.split(',');
  //     });
  // }
  rerender(): void {
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.destroy();
      this.dtTrigger.next();
    });
  }
  ngAfterViewInit() {
    this.dtTrigger.next();
    // this.UserID = this.UserID
  }
  delete(id) {
    this.isLoading = true;
    Swal.fire({
      title: "Are you sure?",
      text: "Do you want to delete this Area-alert detail?",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "No",
      confirmButtonClass: "btn btn-danger mt-2",
      cancelButtonClass: "btn btn-success ml-2 mt-2",
      buttonsStyling: false,
      showConfirmButton: true,
    }).then((result) => {
      if (result.value) {
        this.gs.deleteArealert(id).subscribe((res) => {
          console.log("Delete", res);
          Swal.fire({
            title: "Success",
            text: "Data Deleted successfully.",
            type: "success",
            showConfirmButton: false,
            timer: 1500,
          }).then(() => {
            this.rerender();
          });
          this.isLoading = false;
        });
      }
    });
    this.getusersbyid();
  }
  getusertpbyid() {
    this.gs.getusertpbyid(this.UserID).subscribe((res: any) => {
      this.user = res.data[0];
      this.user.MobileNo = this.user.MobileNo.split(",");
      this.user.EmailID = this.user.EmailID.split(",");
    });
  }
  getusersbyid() {
    this.isLoading = true;
    this.gs.getusersbyid(this.UserID).subscribe(
      (res: any) => {
        this.isLoading = false;
        this.user = res.data[0];
        this.user.mobileno = this.user.MobileNo.split(",");
        this.user.email = this.user.EmailID.split(",");
        localStorage.setItem("PlanId", this.PlanId);
      },
      (error) => {
        this.isLoading = false;
        Swal.fire({
          title: error.status,
          text: "Internal Server Error",
          type: "error",
        });
      }
    );
  }
  areaAlert() {
    this.router.navigate(["users/addauction"], {
      state: { UserId: this.UserID, isEdit: false },
    });
    this.close();
  }
  close() {
    this.dialog.closeAll();
  }
}
